import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import "./Homepage.css";
import DatePicker from "../../components/UI/DatePicker/DatepickerComponent";

import logo from "../../assets/images/rr.svg";

class Homepage extends Component {
  render() {
    return (
      <>
        <div className="homepage">
          <img src={logo} alt="Registar revizora logo" style={{ marginBottom: "60px", width:"240px" }} />

          <h2 className="text">
            Dobro došli na početnu stranicu Registra revizora
          </h2>
        </div>
      </>
    );
  }
}

export default Homepage;
